import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class DiscoverPlugin extends SmartenitPlugin {
  private interval: any;
  private iteration: number;
  private progress: number;
  private discovering: boolean;
  private discoverTime: number;

  public onDurationReceived: Subject<any> = new Subject<any>();

  public onInit() {
    if (
      this.state != null &&
      this.state.discovering &&
      this.state.hasOwnProperty('discoverTime') &&
      this.state.hasOwnProperty('iteration')
    ) {
      this.startInterval(this.state.discoverTime, this.state.iteration);
    }
  }

  public startDiscovery(discoverTime: number = 254): void {
    this.reset();

    const payload = { duration: discoverTime };
    this.discovering = true;

    this.startInterval(discoverTime);

    this.executeMethod(
      this.componentId,
      this.processorName,
      'discover',
      payload
    );
  }

  private startInterval(discoverTime: number, currentIteration?: number) {
    clearInterval(this.interval);

    if (currentIteration !== undefined) {
      if (currentIteration >= discoverTime) {
        this.reset();
        return;
      }
      this.iteration = currentIteration;
    }

    this.discoverTime = discoverTime;

    this.interval = setInterval(() => {
      this.progress = Math.floor(this.iteration++ / this.discoverTime * 100);
      this.saveState(
        {
          discoverTime: this.discoverTime,
          discovering: this.discovering,
          iteration: this.iteration,
          progress: this.progress
        },
        this.discoverTime - this.iteration
      );

      this._onUpdate.next({ progress: this.progress });

      if (this.iteration >= this.discoverTime) {
        clearInterval(this.interval);
        this.reset();
      }
    }, 1000);
  }

  public getProgress(): number {
    return this.progress;
  }

  public stopDiscovery(): void {
    this.reset();

    const payload = { duration: 0 };
    this.executeMethod(
      this.componentId,
      this.processorName,
      'discover',
      payload
    );
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'discoverTime') {
      this.onDurationReceived.next(response.value);
    }

    return this.state;
  }

  private reset() {
    this.iteration = 1;
    this.progress = 0;
    clearInterval(this.interval);
    this.discovering = false;

    this.saveState({
      discovering: this.discovering,
      iteration: this.iteration,
      progress: this.progress
    });
  }

  public getDuration() {
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      'discoverTime',
      null,
      false,
      'cached=false'
    );
  }
}
